import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { ContentBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { Title } from '@/common/title/Title';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { GrossSalesCustChart } from '../charts/GrossSalesCustChart';
import { GrossSalesProdChart } from '../charts/GrossSalesProdChart';
import { PymtChart } from '../charts/PymtChart';
import { PymtVsChart } from '../charts/PymtVsChart';
import { SalesVsChart } from '../charts/SalesVsChart';


export const UcbInctvClaimDashboard = () => {
  // TODO: Get periods from back end
  const periods = ['2024Q1', '2024Q2', '2024Q3', '2024Q4', '2025Q1', '2025Q2', '2025Q3','2025Q4', '2026Q1', '2026Q2', '2026Q3','2026Q4'];

  const [startPeriod, setStartPeriod] = useState('2025Q1');
  const [endPeriod, setEndPeriod] = useState('2026Q4');

  return (
    <ContentBox>
      
      <Title icon={fas.faChartLine} title="DSA/SD Dashboard" />
      

      {/* Filters */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        {/* Start Period */}
        <FormControl fullWidth>
          <InputLabel>Start Period</InputLabel>
          <Select value={startPeriod} data-test-id={'qtr-start-dropdown'} onChange={event => setStartPeriod(event.target.value)}>
            {periods.map(period => <MenuItem data-test-id={`select-"${period}"`} key={period} value={period}>{period}</MenuItem>)}
          </Select>
        </FormControl>

        {/* End Period */}
        <FormControl fullWidth>
          <InputLabel>End Period</InputLabel>
          <Select value={endPeriod} data-test-id={'qtr-end-dropdown'} onChange={event => setEndPeriod(event.target.value)}>
            {periods.map(period => <MenuItem data-test-id={`select-"${period}"`} key={period} value={period}>{period}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>

      {/* Graphs */}
      <SpacerLayout>
        <Spacer vertical>
            <Spacer>
                <DashboardCard title="Quarter Over Quarter DSA Sales" data-test-id={'dsasales-chart'}>
                    <GrossSalesProdChart startPeriod={startPeriod} endPeriod={endPeriod} ctrtDsaSd={'DSA'}/>
                </DashboardCard>
                <DashboardCard title="Quarter Over Quarter SD Sales" data-test-id={'sdsales-chart'}>
                    <GrossSalesProdChart startPeriod={startPeriod} endPeriod={endPeriod} ctrtDsaSd={'SD'}/>
                </DashboardCard>
            </Spacer>
            <Spacer>
                <DashboardCard title="Quarter Over Quarter DSA Sales (By Payer)" data-test-id={'dsasalesbypayer-chart'}>
                    <GrossSalesCustChart startPeriod={startPeriod} endPeriod={endPeriod} ctrtDsaSd={'DSA'}/>
                </DashboardCard>
                <DashboardCard title="Quarter Over Quarter SD Sales (By Payer)" data-test-id={'sdsalesbypayer-chart'}>
                    <GrossSalesCustChart startPeriod={startPeriod} endPeriod={endPeriod} ctrtDsaSd={'SD'}/>
                </DashboardCard>
            </Spacer>
            <Spacer>
                <DashboardCard title="Quarter Over Quarter DSA Pymts" data-test-id={'dsapymts-chart'}>
                    <PymtChart startPeriod={startPeriod} endPeriod={endPeriod} pymtType={'DSA'}/>
                </DashboardCard>
                <DashboardCard title="Quarter Over Quarter SD Pymts" data-test-id={'sdpymts-chart'}>
                    <PymtChart startPeriod={startPeriod} endPeriod={endPeriod} pymtType={'SD'}/>
                </DashboardCard>
            </Spacer>
            <Spacer>
                <DashboardCard title="Quarter Over Quarter SD Vs DSA Pymts" data-test-id={'pymtvs-chart'}>
                    <PymtVsChart startPeriod={startPeriod} endPeriod={endPeriod}/>
                </DashboardCard>
                <DashboardCard title="Quarter Over Quarter SD Vs DSA Sales" data-test-id={'salesvs-chart'}>
                    <SalesVsChart startPeriod={startPeriod} endPeriod={endPeriod}/>
                </DashboardCard>
            </Spacer>
        </Spacer>
      </SpacerLayout>
    
      
    </ContentBox>

    );
};